<div class="questions-scrollable-area">
  @if (questions().length === 0 && !previewMode()) {
    <div class="empty-state-menu">
      <app-add-question-button (add)="onAddNew()" [disabled]="isReadOnly()"></app-add-question-button>
    </div>
  }
  <div class="questions-container">
    @for (question of questions(); track question.id; let i = $index; let last = $last) {
      <div
        class="question-row"
        [attr.data-question-id]="question.id"
        [class.drag-over]="dragOverIndex() === i"
        [class.dragging]="draggedQuestionId() === question.id"
        [class.editing]="question.isEditing ?? true"
        (mouseenter)="onQuestionRowMouseEnter(question.id, last)"
        (mouseleave)="onQuestionRowMouseLeave(question.id, $event)"
        (dragover)="onDragOver($event, i)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event, i)">
        <div class="question-row-content"
             (dragover)="onDragOver($event, i); $event.stopPropagation()"
             (drop)="onDrop($event, i); $event.stopPropagation()">
          <div class="question-menu"
               [class.visible]="isQuestionMenuVisible(question, last)"
               (mouseenter)="onQuestionRowMouseEnter(question.id, last)"
               (mouseleave)="onQuestionRowMouseLeave(question.id, $event)"
               (mouseover)="onQuestionRowMouseEnter(question.id, last)">
            <app-form-context-menu
              [questionId]="question.id"
              [isEditing]="question.isEditing ?? true"
              [hasQuestionType]="!!question.questionType"
              (sort)="onSortQuestions()"
              (delete)="onDeleteQuestion(question.id)"
              (insertBelow)="onInsertBelow(question.id)"
              (dragStart)="onDragStart($event, question.id)"
              (dragEnd)="onDragEnd()"
              (accept)="onAcceptQuestion(question.id)"
              (edit)="onEditQuestion(question.id)">
            </app-form-context-menu>
          </div>
          <div class="question-content">
            <!-- A builder control: read-only shows the form as the applicant sees it,
                 where the label's own * marks required questions. -->
            @if (!isReadOnly() && question.questionType !== QuestionType.Section && question.questionType !== QuestionType.Title && question.questionType !== QuestionType.HelperText) {
              <div class="required-toggle-wrapper">
                <button
                  type="button"
                  class="required-toggle"
                  [class.required]="question.isRequired"
                  (click)="onToggleRequired(question.id)"
                  [disabled]="isReadOnly()"
                  [attr.aria-label]="question.isRequired ? 'Mark as optional' : 'Mark as required'">
                  <i class="pi pi-asterisk"></i>
                </button>
                <span class="required-tooltip">Required</span>
              </div>
            }
            @if (showQuestionNumbers() && question.questionType !== QuestionType.Section && question.questionType !== QuestionType.Title && question.questionType !== QuestionType.HelperText) {
              <span class="question-number">{{ question.questionNumber || (i + 1) }}.</span>
            }
            @if (question.questionType) {
              <div class="question-component-wrapper">
                <app-question-container
                  [question]="question"
                  [isEditing]="!isReadOnly() && (question.isEditing ?? true)"
                  [disabled]="isReadOnly()"
                  (questionChange)="onQuestionChange($event)"
                  (configChange)="onQuestionConfigChange(question.id, $event)"
                  (delete)="onDeleteQuestion(question.id)">
                </app-question-container>
              </div>
            } @else {
              <input
                type="text"
                class="question-label-input"
                placeholder="Select a question type from the palette"
                [value]="question.labelText"
                [attr.data-question-input-id]="question.id"
                readonly>
            }
          </div>
        </div>
      </div>
    }
    @if (questions().length > 0 && !previewMode()) {
      <div class="add-new-row-menu">
        <app-add-question-button (add)="onAddNew()" [disabled]="isReadOnly()"></app-add-question-button>
      </div>
    }
  </div>
</div>

